var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1779 12.0889C24.1779 17.6597 14.0889 29.7947 14.0889 29.7947C14.0889 29.7947 4 17.6597 4 12.0889C4 9.41319 5.06294 6.84703 6.95499 4.95499C8.84703 3.06294 11.4132 2 14.0889 2C16.7647 2 19.3309 3.06294 21.2229 4.95499C23.115 6.84703 24.1779 9.41319 24.1779 12.0889V12.0889Z",
    stroke: "#F07F3C",
    strokeWidth: 2.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0888 16.4198C16.4657 16.4198 18.3925 14.493 18.3925 12.1162C18.3925 9.73932 16.4657 7.8125 14.0888 7.8125C11.712 7.8125 9.78516 9.73932 9.78516 12.1162C9.78516 14.493 11.712 16.4198 14.0888 16.4198Z",
    stroke: "#F07F3C",
    strokeWidth: 2.3,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLocation);
export default __webpack_public_path__ + "static/media/c_location.e591222b5f7ab1304807773b146e6bd0.svg";
export { ForwardRef as ReactComponent };